import { render, staticRenderFns } from "./courseLeadersList.vue?vue&type=template&id=695b3e40&scoped=true&lang=pug"
import script from "./courseLeadersList.vue?vue&type=script&lang=js"
export * from "./courseLeadersList.vue?vue&type=script&lang=js"
import style0 from "./courseLeadersList.vue?vue&type=style&index=0&id=695b3e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b3e40",
  null
  
)

export default component.exports